import { Utils } from '../classes/Utils';
import { clearTempMarkup, addTempMarkup, getAddress } from '../helpers';
import { ServiceCalls } from '../serviceCalls';
import { Styles } from '../classes/Styles';
const styles = new Styles();
var intro = "<tr><td class='left-float'><b>";
var intro2 = "<tr class='item_desc'><td class='left-float'><b>";
var intro3 = "<tr class='item_desc current_occ'><td class='left-float'><b>";
var outro = " class='right-float'> - </td></tr>";
var util = new Utils();
// Clear title info panel
function getAddressInPoly({ state }) {
  if (state.clickedFeature.geometry) {
    var poly = state.clickedFeature.geometry.components[0].components;
    if (typeof poly[0].components !== 'undefined') {
      if (poly[0].components.length > 0) {
        for (var j = 0; j < state.clickedFeature.geometry.components.length; j++) {
          if (
            state.clickedFeature.geometry.components[j].containsPoint(
              new OpenLayers.Geometry.Point(state.mousePos.lon, state.mousePos.lat),
            )
          ) {
            poly = state.clickedFeature.geometry.components[j].components;
          }
        }
      }
    }
    if (typeof poly[0].components !== 'undefined') poly = poly[0].components;
    if (typeof poly[0].x !== 'undefined') {
      var str = '(';
      for (var i = 0; i < poly.length; i++) {
        str += poly[i].x.toString() + '_' + poly[i].y.toString() + ',';
      }
      str = str.substring(0, str.length - 1) + ')';
      ServiceCalls.callService('getAddressInPoly', {
        poly: str,
      });
    }
  }
}
function infoPanelReset({ attr }) {
  $('#info-panel .header').empty();
  infoPanelResetBody({ attr });
}
export function infoPanelAppendBody({ attrObj, raw, state }) {
  var m;
  if (raw.intersects > 1) {
    $('#info-panel .intersects').text('Show Intersecting Titles (' + raw.intersects + ')');
    $('#info-panel .intersects').prop('disabled', false);
  } else {
    $('#info-panel .intersects').text('No Intersecting Titles');
    $('#info-panel .intersects').prop('disabled', true);
  }

  $('#info-panel .content').append('<table></table>');
  var table = $('#info-panel .content').children();
  table.append(
    typeof attrObj.class_of_title !== 'undefined'
      ? attrObj.class_of_title
      : `${intro}${util.correct('class_of_title')}:</b></td><td id='attr_class_of_title'${outro}`,
  );
  table.append(
    typeof attrObj.registered_status !== 'undefined'
      ? attrObj.registered_status
      : `${intro}${util.correct('registered_status')}:</b></td><td id='attr_registered_status'${outro}`,
  );
  table.append(
    typeof attrObj.insert_date !== 'undefined'
      ? attrObj.insert_date
      : `${intro}${util.correct('insert_date')}:</b></td><td id='attr_insert_date'${outro}`,
  );
  table.append(
    typeof attrObj.update_date !== 'undefined'
      ? attrObj.update_date
      : `${intro}${util.correct('update_date')}:</b></td><td id='attr_update_date'${outro}`,
  );
  const updatedDate = state.updatedData.find(o => o.view_name === 'vw_landreg_titles') || {
    last_updated: 'Unknown',
  };
  table.append(
    `${intro}Dataset Last Updated:</b></td><td id='attr_last_updated' class='right-float'>${updatedDate.last_updated}</td></tr>`,
  );
  var sp = true;
  var subtable, obj;
  if (typeof attrObj.corporate !== 'undefined') {
    table.append("<tr><td colspan='2'>&nbsp;</td></tr>");
    sp = false;
    table.append(
      `${intro}Commercial & Corporate:</b></td> <td class="right-float" id="attr_moreinfo"><a onclick="window.showSection('corporate')" href="#" id="more_info">Yes - Click Here</a></td></tr>`,
    );
    $('#info-panel .corporate-content .corporate-subcontent').append('<table></table>');
    subtable = $('#info-panel .corporate-content .corporate-subcontent').children();
    $('#info-panel .corporate-content .corporate-subcontent').css(
      'font-size',
      raw.corporate.length > 1 ? '11px' : '13px',
    );
    for (m = 0; m < 5; m++) {
      var dupe = false;
      if (typeof raw.corporate[m] !== 'undefined') {
        obj = raw.corporate[m];
        if (m > 0) {
          if (obj.co_reg_no == raw.corporate[m - 1].co_reg_no) {
            dupe = true;
          }
        }
        if (!dupe) {
          subtable.append(
            typeof obj.property_address !== 'undefined'
              ? `${intro}${util.correct('property_address')}:</b></td><td class='right-float'>${
                  obj.property_address
                }</td></tr>`
              : `${intro}${util.correct('property_address')}:</b></td><td class='right-float'> - </td></tr>`,
          );
          let propname = 'Proprietor Name';
          let propadd = 'Proprietor Address';
          let propcat = 'Proprietorship';
          let propreg = 'Company Reg No.';
          if (obj.proprietor_name_1 && obj.proprietor_name_2) {
            propname = util.correct('proprietor_name_1');
            propadd = util.correct('proprietor_1_address_1');
            propcat = util.correct('proprietorship_category_1');
            propreg = util.correct('company_registration_no_1');
          }
          subtable.append(
            typeof obj.proprietor_name_1 !== 'undefined'
              ? intro + propname + ":</b></td><td class='right-float'>" + obj.proprietor_name_1 + '</td></tr>'
              : intro + propname + ":</b></td><td class='right-float'> - </td></tr>",
          );
          subtable.append(
            typeof obj.proprietor_1_address_1 !== 'undefined'
              ? intro + propadd + ":</b></td><td class='right-float'>" + obj.proprietor_1_address_1 + '</td></tr>'
              : intro + propadd + ":</b></td><td class='right-float'> - </td></tr>",
          );
          subtable.append(
            typeof obj.proprietorship_category_1 !== 'undefined'
              ? intro + propcat + ":</b></td><td class='right-float'>" + obj.proprietorship_category_1 + '</td></tr>'
              : intro + propcat + ":</b></td><td class='right-float'> - </td></tr>",
          );
          subtable.append(
            typeof obj.company_registration_no_1 !== 'undefined'
              ? intro + propreg + ":</b></td><td class='right-float'>" + obj.company_registration_no_1 + '</td></tr>'
              : intro + propreg + ":</b></td><td class='right-float'> - </td></tr>",
          );
          for (var i = 2; i <= 4; i++) {
            propname = util.correct('proprietor_name_' + i);
            propadd = util.correct('proprietor_' + i + '_address_1');
            if (obj['proprietor_name_' + i]) {
              subtable.css('font-size', i > 2 ? '11px' : '13px');
              if (i == 2) subtable.append("<tr><td colspan='2' style='height:2px'><hr class='faint' /></td></tr>");
              subtable.append(
                typeof obj['proprietor_name_' + i] !== 'undefined'
                  ? intro + propname + ":</b></td><td class='right-float'>" + obj['proprietor_name_' + i] + '</td></tr>'
                  : intro + propname + ":</b></td><td class='right-float'> - </td></tr>",
              );
              subtable.append(
                typeof obj['proprietor_' + i + '_address_1'] !== 'undefined'
                  ? intro +
                      propadd +
                      ":</b></td><td class='right-float'>" +
                      obj['proprietor_' + i + '_address_1'] +
                      '</td></tr>'
                  : intro + propadd + ":</b></td><td class='right-float'> - </td></tr>",
              );
              subtable.append(
                typeof obj['proprietorship_category_' + i] !== 'undefined'
                  ? intro +
                      util.correct('proprietorship_category_' + i) +
                      ":</b></td><td class='right-float'>" +
                      obj['proprietorship_category_' + i] +
                      '</td></tr>'
                  : intro +
                      util.correct('proprietorship_category_' + i) +
                      ":</b></td><td class='right-float'> - </td></tr>",
              );
              subtable.append(
                typeof obj['company_registration_no_' + i] !== 'undefined'
                  ? intro +
                      util.correct('company_registration_no_' + i) +
                      ":</b></td><td class='right-float'>" +
                      obj['company_registration_no_' + i] +
                      '</td></tr>'
                  : intro +
                      util.correct('company_registration_no_' + i) +
                      ":</b></td><td class='right-float'> - </td></tr>",
              );
              subtable.append("<tr><td colspan='2' style='height:2px'><hr class='faint' /></td></tr>");
            }
          }
          subtable.append(
            typeof obj.tenure !== 'undefined'
              ? intro + util.correct('tenure') + ":</b></td><td class='right-float'>" + obj.tenure + '</td></tr>'
              : intro + util.correct('tenure') + ":</b></td><td class='right-float'> - </td></tr>",
          );
          subtable.append(
            typeof obj.date_proprietor_added !== 'undefined'
              ? intro +
                  util.correct('date_proprietor_added') +
                  ":</b></td><td class='right-float'>" +
                  util.modify('date_proprietor_added', obj.date_proprietor_added) +
                  '</td></tr>'
              : intro + util.correct('date_proprietor_added') + ":</b></td><td class='right-float'> - </td></tr>",
          );
          if (raw.corporate[m].company_registration_no_1) {
            subtable.append(
              intro +
                "Link:</b></td><td class='right-float'><a target='_blank' href='http://beta.companieshouse.gov.uk/company/" +
                util.pad(raw.corporate[m].company_registration_no_1, 8) +
                "'>Companies House</a></td></tr>",
            );
          }
          subtable.append("<tr><td colspan='2' style='height:2px'><hr class='faint' /></td></tr>");
        }
      }
    }
  }
  if (typeof attrObj.daylist !== 'undefined') {
    if (sp) table.append("<tr><td colspan='2'>&nbsp;</td></tr>");
    sp = false;
    var dlArray = [
      'abr',
      'application_service_name',
      'application_type_code',
      'application_group',
      'dealing_code',
      'lodged_by',
      'customer_reference',
      'intake_date',
      'reg_addr_a1',
      'completed_date',
      'application_status',
    ];
    table.append(
      intro +
        'Day List Application:</b></td> <td class="right-float" id="attr_moreinfo"><a onclick="window.showSection(\'daylist\')" href="#" id="more_info">Yes - Click Here - Sample Data ONLY</a></td></tr>',
    );
    $('#info-panel .daylist-content .daylist-subcontent').append('<table></table>');
    subtable = $('#info-panel .daylist-content .daylist-subcontent').children();
    $('#info-panel .daylist-content .daylist-subcontent').css('font-size', raw.daylist.length > 1 ? '11px' : '13px');
    for (m = 0; m < raw.daylist.length; m++) {
      if (typeof raw.daylist[m] !== 'undefined') {
        obj = raw.daylist[m];
        for (var x = 0; x < dlArray.length; x++) {
          subtable.append(
            typeof obj[dlArray[x]] !== 'undefined'
              ? intro +
                  util.correct(dlArray[x]) +
                  ":</b></td><td class='right-float'>" +
                  util.modify(dlArray[x], obj[dlArray[x]]) +
                  '</td></tr>'
              : intro + util.correct(dlArray[x]) + ":</b></td><td class='right-float'> - </td></tr>",
          );
        }
        subtable.append("<tr><td colspan='2' style='height:2px'><hr class='faint' /></td></tr>");
      }
    }
  }

  if (typeof attrObj.address1 !== 'undefined') {
    if (sp) table.append("<tr><td colspan='2'>&nbsp;</td></tr>");
    table.append(
      intro +
        'Overseas Ownership:</b></td> <td class="right-float" id="attr_moreinfo"><a onclick="window.showSection(\'overseas\')" href="#" id="more_info">Yes - Click Here</a></td></tr>',
    );
    $('#info-panel .overseas-content .overseas-subcontent').append('<table></table>');
    var subtable2 = $('#info-panel .overseas-content .overseas-subcontent').children();
    subtable2.append(
      typeof attrObj.property_address !== 'undefined'
        ? attrObj.property_address
        : intro + util.correct('property_address') + ":</b></td><td id='attr_property_address'" + outro,
    );
    subtable2.append(
      typeof attrObj.country_incorporated_1 !== 'undefined'
        ? attrObj.country_incorporated_1
        : intro + util.correct('country_incorporated_1') + ":</b></td><td id='attr_update_date'" + outro,
    );
    subtable2.append(
      typeof attrObj.price_paid !== 'undefined'
        ? attrObj.price_paid
        : intro + util.correct('price_paid') + ":</b></td><td id='attr_update_date'" + outro,
    );
    if (attrObj['proprietor_name_1'] && !attrObj['proprietor_name_2']) {
      attrObj['proprietor_name_1'] = attrObj['proprietor_name_1'].replace('Name 1', 'Name');
    }

    for (m = 1; m < 5; m++) {
      if (typeof raw['proprietor_' + m + '_address_1'] !== 'undefined') {
        subtable2.css('font-size', m > 2 ? '11px' : '13px');
        subtable2.append(
          typeof attrObj['proprietor_name_' + m] !== 'undefined'
            ? attrObj['proprietor_name_' + m]
            : intro + util.correct('proprietor_name_' + m) + ":</b></td><td id='attr_name" + m + "'" + outro,
        );
        if (
          attrObj['proprietor_1_address_1'] &&
          !attrObj['proprietor_2_address_1'] &&
          !attrObj['proprietor_1_address_2']
        ) {
          attrObj['proprietor_1_address_1'] = attrObj['proprietor_1_address_1'].replace('Address 1', 'Address');
        }

        subtable2.append(
          typeof attrObj['proprietor_' + m + '_address_1'] !== 'undefined'
            ? attrObj['proprietor_' + m + '_address_1']
            : intro +
                util.correct('proprietor_' + m + '_address_1') +
                ":</b></td><td id='attr_address" +
                m +
                "'" +
                outro,
        );
        subtable2.append(
          typeof attrObj['proprietor_' + m + '_address_2'] !== 'undefined' && attrObj['proprietor_' + m + '_address_2'],
        );
        subtable2.append(
          typeof attrObj['proprietor_' + m + '_address_3'] !== 'undefined' && attrObj['proprietor_' + m + '_address_3'],
        );
        subtable2.append(
          typeof attrObj['proprietorship_category_' + m] !== 'undefined'
            ? attrObj['proprietorship_category_' + m]
            : intro +
                util.correct('proprietorship_category_' + m) +
                ":</b></td><td id='attr_proprietorship_" +
                m +
                "'" +
                outro,
        );
        subtable2.append("<tr><td colspan='2' style='height:2px'><hr class='faint' /></td></tr>");
      }
    }
  }
  table.append("<tr><td colspan='2' style='height:2px'><hr /></td></tr>");
  table.append(attrObj.uprn);
  table.append(
    typeof attrObj.address !== 'undefined'
      ? attrObj.address
      : intro + util.correct('address') + ":</b></td><td id='attr_address'" + outro,
  );
  table.append(
    typeof attrObj.current_occupier !== 'undefined'
      ? attrObj.current_occupier
      : intro3 + util.correct('current_occupier') + ":</b></td><td id='attr_current_occupier'" + outro,
  );
  table.append(
    typeof attrObj.primary_desc !== 'undefined'
      ? attrObj.primary_desc
      : intro2 + util.correct('primary_desc') + ":</b></td><td id='attr_primary_desc'" + outro,
  );
  table.append(
    typeof attrObj.secondary_desc !== 'undefined'
      ? attrObj.secondary_desc
      : intro2 + util.correct('secondary_desc') + ":</b></td><td id='attr_secondary_desc'" + outro,
  );
  table.append(
    typeof attrObj.tertiary_desc !== 'undefined'
      ? attrObj.tertiary_desc
      : intro2 + util.correct('tertiary_desc') + ":</b></td><td id='attr_tertiary_desc'" + outro,
  );
  table.append(
    typeof attrObj.add_source !== 'undefined'
      ? attrObj.add_source
      : intro + util.correct('add_source') + ":</b></td><td id='add_source'" + outro,
  );
  table.append(
    typeof attrObj.add_source_descr !== 'undefined'
      ? attrObj.add_source_descr
      : intro + util.correct('add_source_descr') + ":</b></td><td id='add_source_desc'" + outro,
  );
  raw.primary_desc && raw.primary_desc !== '-' ? $('.item_desc').show() : $('.item_desc').hide();
  var mod = $('#snaps-button').is(':hidden') ? 200 : 170;
  $('#info-panel').height($('#info-panel .content').height() + mod);
}

// Clear title info panel body
function infoPanelResetBody({ attr }) {
  $('#info-panel .content, #info-panel .extra-content .extra-subcontent').empty();
  $('#info-panel .extra-content').hide();
  $('#info-panel .content').show();
  $('#info-panel .remove, #info-panel .save').prop('disabled', false);
  if (attr.progress == 'sent') $('#info-panel .remove, #info-panel .save').prop('disabled', true);
  if (attr.progress == 'saved') $('#info-panel .save').prop('disabled', true);
}
function infoPanelPopulate({ attr, state }) {
  var attrObj = [];
  var raw = [];
  state.multi_uprn = false;
  var sel;
  var selmid;
  var selcount = 0;
  var col;
  var tag;
  var featClicked = function (idx) {
    if (state.clickedFeatures[idx].attributes.class_of_title.indexOf('leasehold') > -1) {
      col = '#0000ff';
      tag = 'Leasehold';
    } else if (state.clickedFeatures[idx].attributes.class_of_title.indexOf('freehold') > -1) {
      col = '#e00000';
      tag = 'Freehold';
    } else {
      col = '#000000';
      tag = 'Other';
    }
    selmid +=
      "<option style='color:" +
      col +
      "' value='" +
      state.clickedFeatures[idx].attributes.title_no +
      "'>" +
      state.clickedFeatures[idx].attributes.title_no +
      ' - ' +
      tag +
      '</option>';
    selcount++;
    if (!state.initcol) state.initcol = col;
  };
  var eachArr = function (i) {
    sel += "<option value='" + i + "'>" + i + '</option>';
  };
  for (var item in attr) {
    var multi = false;
    if (util.correct(item)) {
      var itemval = util.str_tidy(attr[item]);
      if (item == 'uprn') {
        if (attr[item].toString().indexOf(',') > -1) multi = true;
        if (attr[item].toString() === '') {
          getAddressInPoly({ state });
        } else if (attr[item].toString() !== '' && typeof attr['town'] === 'undefined') {
          getAddress(attr[item].toString());
        }
      }
      if (item == 'primary_desc') {
        $('.item_desc').show();
      }
      if (item == 'corporate') {
        raw[item] = itemval;
      }
      if (item == 'proprietor_1_address_1' && !attr['proprietor_2_address_1']) {
        attrObj[item] = intro + "Proprietor Address:</b></td><td class='right-float'>" + sel + '</td></tr>';
      }
      if (item == 'title_no') {
        if (state.clickedFeatures.length == 1) {
          attrObj[item] =
            intro +
            util.correct(item) +
            ":</b></td> <td class='right-float' id='attr_" +
            item +
            "'>" +
            util.modify(item, itemval) +
            "<span onclick='window.downloadTitles()'><i title='Download the HMLR title information in a spreadsheet' class='orange fa fa-download iconpad' aria-hidden='true'></i></span></td></tr>";
          raw[item] = itemval;
        } else {
          state.initcol = null;
          $.each(state.clickedFeatures, featClicked);
          sel = "<select class='infobox' id='multititle' style='color:" + state.initcol + "'>";
          sel +=
            selmid +
            "</select><span class='orange' style='font-size:14px'>&nbsp; (<span id='selcount'>" +
            selcount +
            "</span>)</span>&nbsp;<span onclick='window.downloadTitles()'><i title='Download the HMLR title information in a spreadsheet' class='orange fa fa-download iconpad' aria-hidden='true'></i></span>";
          attrObj[item] = intro + util.correct(item) + ":</b></td><td class='right-float'>" + sel + '</td></tr>';
        }
      }
      if (typeof itemval == 'undefined') itemval = '-';
      if (state.clickedFeatures.length > 1 && item == 'title_no') {
        //
      } else if (!multi) {
        if (itemval !== null) {
          if (item.search(/_desc$/) !== -1)
            attrObj[item] =
              intro2 +
              util.correct(item) +
              ":</b></td> <td class='right-float' id='attr_" +
              item +
              "'>" +
              util.modify(item, itemval) +
              '</td></tr>';
          else if (item.search(/current_occ/) !== -1)
            attrObj[item] =
              intro3 +
              util.correct(item) +
              ":</b></td> <td class='right-float' id='attr_" +
              item +
              "'>" +
              util.modify(item, itemval) +
              '</td></tr>';
          else if (item === 'title_no')
            attrObj[item] =
              intro +
              util.correct(item) +
              ":</b></td> <td class='right-float' id='attr_" +
              item +
              "'>" +
              util.modify(item, itemval) +
              "&nbsp;<span onclick='window.downloadTitles()'><i title='Download the HMLR title information in a spreadsheet' class='orange fa fa-download iconpad' aria-hidden='true'></i></span></td></tr>";
          else
            attrObj[item] =
              intro +
              util.correct(item) +
              ":</b></td> <td class='right-float' id='attr_" +
              item +
              "'>" +
              util.modify(item, itemval) +
              '</td></tr>';
        }
        raw[item] = itemval;
      } else {
        state.multi_uprn = true;
        sel = "<select class='infobox' id='multiuprn'>";
        var arr = itemval.split(',');
        arr.sort();
        arr.forEach(eachArr);
        sel += '</select>';
        if (item.search('_desc') !== -1)
          attrObj[item] = intro2 + util.correct(item) + ":</b></td><td class='right-float'>" + sel + '</td></tr>';
        else if (item.search('current_occ') !== -1)
          attrObj[item] = intro3 + util.correct(item) + ":</b></td><td class='right-float'>" + sel + '</td></tr>';
        else attrObj[item] = intro + util.correct(item) + ":</b></td><td class='right-float'>" + sel + '</td></tr>';
      }
    }
  }
  raw.intersects = attr.intersects;
  return [attrObj, raw];
}

function infoPanelAppend({ attrObj, raw, state }) {
  $('#info-panel .header').append('<table></table>');
  $('#info-panel .header')
    .children()
    .append(
      typeof attrObj.title_no !== 'undefined'
        ? attrObj.title_no
        : intro + util.correct('title_no') + ":</b></td><td id='attr_title_no'" + outro,
    );
  infoPanelAppendBody({ attrObj, raw, state });
}

export const infoPanelSetup = function ({ state, ol, styles }) {
  ol.controls.click.deactivate();
  ol.layers.vector.redraw();
  if (state.info_timer) {
    clearTimeout(state.info_timer);
    state.info_timer = null;
  }
  state.info_timer = setTimeout(function () {
    if (!state.queryActive) {
      state.clickedFeature = state.clickedFeatures[0];
      var attr = state.clickedFeature.attributes;
      infoPanelReset({ attr });
      var obj = infoPanelPopulate({ attr, state });
      infoPanelAppend({ attrObj: obj[0], raw: obj[1], state });
      var mod = $('#snaps-button').is(':hidden') ? 200 : 170;
      $('#info-panel').height($('#info-panel .content').height() + mod);
      if (state.multi_uprn) {
        $('#multiuprn').change(function () {
          getAddress($('#multiuprn').val());
        });
        getAddress($('#multiuprn').val());
      }
      if (state.clickedFeatures.length > 1) {
        state.multiTitle = true;
        $('#multititle').change(function (e) {
          var idx = e.target.selectedIndex;
          state.clickedFeature = state.clickedFeatures[idx];
          if (state.clickedFeature) {
            clearTempMarkup(ol.layers.tempMarkup);
            addTempMarkup({ feature: state.clickedFeature, styles, ol });
            var attr = state.clickedFeature.attributes;
            infoPanelResetBody({ attr });
            var attrObj = infoPanelPopulate({ attr, state });
            $('#info-panel').height($('#info-panel .content').height() + mod);
            infoPanelAppendBody({ attrObj: attrObj[0], raw: attrObj[1], state });
            if (state.multi_uprn) {
              $('#multiuprn').change(function () {
                getAddress($('#multiuprn').val());
              });
              getAddress($('#multiuprn').val());
            }
            $('#info-panel').show();
            $('#info-panel .header').show();

            state.overStatus = false;
            state.currentFeature = state.clickedFeature;
            state.infoActive = true;
            var selCol = $('#multititle option:selected').css('color');
            $('#multititle').css('color', selCol);
          }
        });
      } else {
        state.multiTitle = false;
      }
      var saveAllCount = 0;
      for (var n = 0; n < state.clickedFeatures.length; n++) {
        for (var m = 0; m < state.savedFeatures.length; m++) {
          if (state.savedFeatures[m].attributes.title_no == state.clickedFeatures[n].attributes.title_no)
            saveAllCount++;
        }
      }
      $('#saveAllInfo').prop('disabled', saveAllCount == state.clickedFeatures.length);
      if (state.clickedFeatures.length == 1) {
        $('#saveAllInfo').prop('disabled', true);
        $('#removeAllInfo').prop('disabled', true);
      } else {
        $('#removeAllInfo').prop('disabled', false);
      }
      $('#info-panel').show();
      $('#info-panel .header').show();
      $('#multititle').css('color', state.initcol);
      state.currentFeature = state.clickedFeature;
      clearTempMarkup(ol.layers.tempMarkup);
      addTempMarkup({ feature: state.currentFeature, styles, ol });
      state.infoActive = true;
      $('#info-panel').height($('#info-panel .content').height() + mod);
    }
  }, 200);
};
export function repopulateInfoBox({ newFeat, state, ol }) {
  var heldFeatures = state.clickedFeatures.slice(0);
  state.clickedFeatures = [];
  state.snapFeatures = [];
  var i;
  for (i = 0; i < heldFeatures.length; i++) {
    state.clickedFeatures.push(heldFeatures[i]);
    if (state.snapsActive) state.snapFeatures.push(heldFeatures[i]);
    infoPanelSetup({ state, ol, styles });
  }
  for (i = 0; i < newFeat.length; i++) {
    state.clickedFeatures.push(newFeat[i][0]);
    if (state.snapsActive) state.snapFeatures.push(newFeat[i][0]);
    infoPanelSetup({ state, ol, styles });
  }
  newFeat = [];
  if (state.snapsActive) {
    var snapsPrice = util.getPrice(state.snapFeatures.length);
    $('#snapsPrice').text(snapsPrice.toString());
    $('#price2').text(snapsPrice.toString());
  }
  if (!state.snapsActive && !state.noInfoPopup && ol.layers.vector.features.length > 0 && newFeat.length == 0) {
    $('#info-panel').show();
    $('#info-panel .standard').show();
    $('#info-panel .snaps').hide();
    $('#info-panel .header').show();
    state.noInfoPopup = false;
  }
}
export function closeInfo({ state, ol, featClick, setCursor, activateSelect }) {
  $('.saved-poly').removeClass('orangeBG');
  state.snapsActive = false;
  $('#info-panel .standard').show();
  $('#info-panel .snaps').hide();
  state.infoClosed = true;
  state.overcount = 0;
  ol.layers.vector.events.un({ featureclick: featClick });
  ol.layers.vector.events.on({ featureclick: featClick });
  state.infoActive = false;
  if (!state.polysearchModified) {
    if ($('#pan-control').parent().hasClass('active')) ol.controls.click.activate();
  } else {
    state.polysearchModified = false;
    setCursor({ type: 'default' });
    activateSelect();
  }
  $('#info-panel').hide();
  clearTempMarkup(ol.layers.tempMarkup);
  ol.layers.vector.redraw();
  ol.layers.tempMarkup.redraw();
  state.clickedFeatures = [];
}
